import * as C from "../constants";
import { createReducer } from "../utils/misc";

const initialState = {
    dailySales: {
        data: [],
        month: null,
        year: null,
        isLoading: false,
        isLoaded: false,
    },
    monthSumSales: {
        data: [],
        year: null,
        isLoading: false,
        isLoaded: false,
    },
    monthAverageSales: {
        data: [],
        year: null,
        isLoading: false,
        isLoaded: false,
    },
    paymentTypesShareInSales: {
        data: [],
        isLoading: false,
        isLoaded: false,
    },
    machines: {
        data: [],
        isLoaded: false,
        isLoading: false,
    },
    dailySalesCount: {
        data: [],
        month: null,
        year: null,
        isLoaded: false,
        isLoading: false,
    },
    statusText: "",
};

export default createReducer(initialState, {
    [C.GET_STATISTICS_DAILY_SALES_REQUEST]: (state) => ({
        ...state,
        dailySales:{
            ...state.dailySales,
            isLoading: true,
        }
    }),
    [C.GET_STATISTICS_DAILY_SALES_FAILURE]: (state) => ({
        ...state,
        dailySales: {
            ...state.dailySales,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка дневных продаж"
    }),
    [C.GET_STATISTICS_DAILY_SALES_SUCCESS]: (state, payload) => ({
        ...state,
        dailySales: {
            ...state.dailySales,
            isLoading: false,
            isLoaded: true,
            data: payload.data,
            month: payload.month,
            year: payload.year,
        }
    }),
    [C.GET_STATISTICS_MONTH_SUM_SALES_REQUEST]: (state) => ({
        ...state,
        monthSumSales: {
            ...state.monthSumSales,
            isLoading: true,
        }
    }),
    [C.GET_STATISTICS_MONTH_SUM_SALES_FAILURE]: (state) => ({
        ...state,
        monthSumSales: {
            ...state.monthSumSales,
            isLoading: false,
            isLoaded: false
        },
        statusText: "Ошибка загрузки списка продаж по месяцам"
    }),
    [C.GET_STATISTICS_MONTH_SUM_SALES_SUCCESS]: (state, payload) => ({
        ...state,
        monthSumSales: {
            ...state.monthSumSales,
            isLoading: false,
            isLoaded: true,
            data: payload.data,
            year: payload.year,
        }
    }),
    [C.GET_STATISTICS_MONTH_AVERAGE_SALES_REQUEST]: (state) => ({
        ...state,
        monthAverageSales: {
            ...state.monthAverageSales,
            isLoading: true,
        }
    }),
    [C.GET_STATISTICS_MONTH_AVERAGE_SALES_FAILURE]: (state) => ({
        ...state,
        monthAverageSales: {
            ...state.monthAverageSales,
            isLoading: false,
            isLoaded: false
        },
        statusText: "Ошибка загрузки списка продаж по месяцам"
    }),
    [C.GET_STATISTICS_MONTH_AVERAGE_SALES_SUCCESS]: (state, payload) => ({
        ...state,
        monthAverageSales: {
            ...state.monthAverageSales,
            isLoading: false,
            isLoaded: true,
            data: payload.data,
            year: payload.year,
        }
    }),
    [C.GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_REQUEST]: (state) => ({
        ...state,
        paymentTypesShareInSales: {
            ...state.paymentTypesShareInSales,
            isLoading: true,
        }
    }),
    [C.GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_FAILURE]: (state) => ({
        ...state,
        paymentTypesShareInSales: {
            ...state.paymentTypesShareInSales,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка долей продаж по типам платежей"
    }),
    [C.GET_STATISTICS_PAYMENT_TYPES_SHARE_IN_SALES_SUCCESS]: (state, payload) => ({
        ...state,
        paymentTypesShareInSales: {
            ...state.paymentTypesShareInSales,
            isLoading: false,
            isLoaded: true,
            data: payload
        }
    }),
    [C.GET_STATISTICS_MACHINES_REQUEST]: (state) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: true,
        }
    }),
    [C.GET_STATISTICS_MACHINES_FAILURE]: (state) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: false,
            isLoaded: false,
        },
        statusText: "Ошибка загрузки списка адресов автоматов."
    }),
    [C.GET_STATISTICS_MACHINES_SUCCESS]: (state, payload) => ({
        ...state,
        machines: {
            ...state.machines,
            isLoading: false,
            isLoaded: true,
            data: payload
        }
    }),
    [C.GET_STATISTICS_DAILY_SALES_COUNT_REQUEST]: (state) => ({
        ...state,
        dailySalesCount: {
            ...state.dailySalesCount,
            isLoading: true
        }
    }),
    [C.GET_STATISTICS_DAILY_SALES_COUNT_FAILURE]: (state) => ({
        ...state,
        dailySalesCount: {
            ...state.dailySalesCount,
            isLoading: false,
            isLoaded: false
        },
        statusText: "Ошибка загрузки количесивенного среза продаж"
    }),
    [C.GET_STATISTICS_DAILY_SALES_COUNT_SUCCESS]: (state, payload) => ({
        ...state,
        dailySalesCount: {
            ...state.dailySalesCount,
            isLoaded: true,
            isLoading: false,
            data: payload.data,
            month: payload.month,
            year: payload.year,
        }
    })
})


// WEBPACK FOOTER //
// ./src/reducers/statistics.js